import { Button } from 'primereact/button';
import React, { FC, useCallback, useEffect, useState } from 'react';

import gameStore from '../../../../store/GameStore';
import tableStore from '../../../../store/TableStore';
import { TableProfits } from '../../../Profits/TableProfits';
import { TableButtonProps } from '../TableButton.types';

export const ButtonWithProfits: FC<TableButtonProps> = ({
  tableId,
  tableDeleted,
}) => {
  const [toggleEventMap, setToggleEventMap] = useState<
    Map<string, React.MouseEvent<HTMLSpanElement>>
  >(new Map());

  useEffect(() => {
    Array.from(toggleEventMap.keys()).forEach(tableId => {
      if (!tableStore.isTableViewing(tableId)) {
        toggleEventMap.delete(tableId);
      }
    });
  }, [gameStore.activeGames.size, tableStore.viewingTableIds.length]);

  const getToggleEvent = useCallback(
    () => toggleEventMap.get(tableId),
    [toggleEventMap],
  );

  return (
    <>
      <Button
        icon="pi pi-chart-line"
        disabled={tableDeleted}
        rounded
        text
        aria-label="table profits"
        tooltip="Profits"
        onClick={event =>
          setToggleEventMap(
            prevState => new Map([...prevState, [tableId, event]]),
          )
        }
      />
      <TableProfits tableId={tableId} toggleEvent={getToggleEvent()} />
    </>
  );
};
